<template>
  <div class="sidebarButton">
    <router-link
      :to="{
        name: 'uploadRecipe',
      }"
      ><div class="icon"><i class="pi pi-plus"></i></div
    ></router-link>
    <router-link
      :to="{
        name: 'likedRecipes',
      }"
      ><div class="icon"><i class="pi pi-heart"></i></div
    ></router-link>
    <router-link
      :to="{
        name: 'myRecipes',
      }"
      ><div class="icon"><i class="pi pi-clone"></i></div
    ></router-link>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
